import React, { useState } from 'react';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';

export default ({ value }) => {
  return <>{value ? <LockOpenIcon /> : <LockIcon />}</>;
};
